import * as React from 'react';
import { default as InlineSVG, InlineSVGProps } from 'react-inlinesvg';

export const SVG = (props: InlineSVGProps) => {
  // Wrap inlinesvg, but cache by default
  return <InlineSVG cacheGetRequests={true} {...props} />;
};

export default SVG;



// WEBPACK FOOTER //
// ./src/app/components/Utils/SVG/index.tsx